import React from "react";
import { withRouter } from "react-router-dom";
import { Dropdown, Avatar, Typography, Image, Row } from "antd";
import shortid from "shortid";
import { Link, useHistory } from "react-router-dom";
import Logo from "../sidebar/logo.png";
import {
  DownOutlined,
  LogoutOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import {
  NavbarContainer,
  Menu,
  ProfileButton,
  NameContainer,
} from "./elements";
import { useUser } from "providers/user";

const { Text } = Typography;

function NavBar() {
  const { user, logout } = useUser();

  const { push } = useHistory();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <NavbarContainer>
      <Menu mode="horizontal">
        <Row
          style={{
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Image
            height={25}
            style={{ marginLeft: 10, marginBottom: 20, width: 110 }}
            preview={false}
            onClick={() => push("/dashboard")}
            src={Logo}
            alt=""
          />

          <Dropdown
            trigger={["click"]}
            overlay={
              <Menu mode="vertical">
                <Menu.ItemGroup title="Cuenta">
                  <Menu.Item
                    key={shortid.generate()}
                    onClick={() => push("/settings")}
                    icon={<SettingOutlined />}
                  >
                    Configuración
                  </Menu.Item>
                </Menu.ItemGroup>
                <Menu.ItemGroup title="Sesión">
                  <Menu.Item
                    key={shortid.generate()}
                    onClick={() => handleLogout()}
                    icon={<LogoutOutlined style={{ color: "red" }} />}
                  >
                    <Link to={"/login"} style={{ color: "red" }}>
                      Salir
                    </Link>
                  </Menu.Item>
                </Menu.ItemGroup>
              </Menu>
            }
          >
            <ProfileButton type="text">
              <Avatar
                style={{ marginRight: 15 }}
                size={35}
                src={user?.profileImg}
              >
                {user?.firstName?.[0]}
              </Avatar>
              <NameContainer>
                <Text
                  style={{ fontSize: 12, color: "#4B89E3" }}
                  type="secondary"
                >
                  Hola,
                </Text>
                <Text style={{ marginTop: -5, color: "#4B89E3" }} strong>
                  {user?.email}
                </Text>
              </NameContainer>
              <DownOutlined />
            </ProfileButton>
          </Dropdown>
        </Row>
      </Menu>
    </NavbarContainer>
  );
}

export default withRouter(NavBar);
